import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import ReviewHeader from "./components/Header/Header";
import ReviewDetails from "./components/ReviewDetails/ReviewDetails";
import * as S from './Reviewpage.styles';
import { paydataSelector } from './redux/selector';
import { getLoadedComponent } from "../../config/omni";
import { useHistory } from 'react-router-dom'
import { SOURCE_TYPE } from "../../config/constants";
import { setter } from '../../utils/storage';
import TripAssistant from "../SeoPage/containers/LeadGenButton/TripAssistant";

const Review = () => {
  const paydata = useSelector(paydataSelector);
  const history = useHistory()
  useEffect(() => {
    return () => {
      if (history.action === "POP") {
        setter(SOURCE_TYPE, [])
      }
    };
  }, [history])
  useEffect(() => {
    getLoadedComponent('ReviewPage')
  }, [])
  return (
    <S.ReviewWrapper>
      {!paydata?.pay_id ? (
        <>
          <ReviewHeader />
          <ReviewDetails />
        </>
      ) : null}
      <TripAssistant pageName="Review"/>
      <div id="gi_paymentframe" className="posRel fl width100 whiteBg" /> 
    </S.ReviewWrapper>
  );
}


export default Review;